export default function SkeletonLoader() {
    return (
      <div className="animate-pulse space-y-6 max-w-6xl mx-auto">
        <div className="h-8 bg-gray-200 rounded w-1/3"></div>
        <div className="grid lg:grid-cols-3 gap-8">
          <div className="lg:col-span-2 space-y-6">
            <div className="h-64 bg-gray-200 rounded-2xl"></div>
            <div className="h-48 bg-gray-200 rounded-2xl"></div>
          </div>
          <div className="h-64 bg-gray-200 rounded-2xl"></div>
        </div>
      </div>
    );
  }